import "js/likes";

const optimizedResize = (function () {
  var callbacks = [],
    running = false;

  // fired on resize event
  function resize() {
    if (!running) {
      running = true;

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks);
      } else {
        setTimeout(runCallbacks, 66);
      }
    }
  }

  // run the actual callbacks
  function runCallbacks() {
    callbacks.forEach(function (callback) {
      callback();
    });
    running = false;
  }

  // adds callback to loop
  function addCallback(callback) {
    if (callback) {
      callbacks.push(callback);
    }
  }

  return {
    // public method to add additional callback
    add: function (callback) {
      if (!callbacks.length) {
        window.addEventListener("resize", resize);
      }
      addCallback(callback);
    },
  };
})();

window.addEventListener("DOMContentLoaded", (event) => {
  // start process
  var device = getDeviceByScreenWidth();
  startGoogleAdx(device);

  optimizedResize.add(function () {
    let device = getDeviceByScreenWidth();
    startGoogleAdx(device);
  });
});

const startGoogleAdx = (device) => {
  const mid = "div-gpt-ad-1591349536027-0-m";
  const did = "div-gpt-ad-1590410262007-0-d"
  let mobile_ad = document.getElementById(mid);
  let desktop_ad = document.getElementById(did);
  console.log("startGoogleAdx >>>>>>", device)
  if (device == 'mobile') {
    if (mobile_ad !== null && !mobile_ad.classList.contains("google-adx-inited")) {
      console.log("Start ADX:", mid);
      googletag.cmd.push(function () {
        googletag.display(mid);
      });
      mobile_ad.classList.add("google-adx-inited");
    }
  } 
  else if (device == 'desktop') {
    if (desktop_ad !== null && !desktop_ad.classList.contains("google-adx-inited")) {
      console.log("Start ADX: ", did);
      googletag.cmd.push(function () {
        googletag.display(did);
      });
      desktop_ad.classList.add("google-adx-inited");
    }
  }
};
